import Immutable from 'immutable';

import {createError} from '../services/errors';
import {buildFetch} from '../services/fetch';
import config from 'config';

export const REPORTS_LOADING_ERROR = 'REPORTS_LOADING_ERROR';
export const REPORTS_LOADING_SUCCESS = 'REPORTS_LOADING_SUCCESS';
export const REPORTS_START_LOADING = 'REPORTS_START_LOADING';

export function loadReportsSuccess(data = {}) {
  return {
    type: REPORTS_LOADING_SUCCESS,
    data
  };
}

export function startLoadingReports() {
  return {
    type: REPORTS_START_LOADING
  };
}

export const loadReportsError = createError(REPORTS_LOADING_ERROR);

export function loadReports(campaignId) {
  return function(dispatch) {
    const fetch = buildFetch(dispatch);
    dispatch(startLoadingReports());
    return fetch(`${config.api}/reports?campaignId=${campaignId}`)
      .then(response => {
        const {reports} = response.data;
        const immutableReports = Immutable.fromJS(reports);
        dispatch(loadReportsSuccess(immutableReports));

        return immutableReports;
      })
      .catch(error => {
        if (error) {
          dispatch(loadReportsError(error.message));

          throw error;
        }
      });
  };
}
